import { Home } from "./home.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";

import { homeState } from "./home.states";
import { AllMaterialModule } from "../all-material.components";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        UIRouterModule.forChild({ states: [homeState] })
    ],
    declarations: [Home]
})
export default class HomeModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/home/home.module.ts